import React, { Component } from 'react';

const backgroundImgURL = '/img/hackathon-dev.jpg';

const styles = {
	landingPage: {
		'backgroundImage': `url(${backgroundImgURL})`,
	},
	profilePic: {
		'margin': '0 auto 20px',
		'width': '200px',
		'height': '200px',
	},
}

export default class LandingPage extends Component {
	render() {
		return (
			<header>
        <div className="container" id="maincontent" tabIndex="-1">
          <div className="row">
            <div className="col-lg-12">
              <div className="intro-text">
								<img
									className="img-responsive img-circle"
									style={styles.profilePic}
									src="/img/Profile.jpg"
									alt="" />
								<h2 className="name">Hello, my name is Justin Tsang</h2>
								<h3>I am a full-time software engineer</h3>
                <hr className="star-light" />
                <span className="skills">Full Stack Engineer - Project Lead - Software Engineer</span>
              </div>
            </div>
          </div>
        </div>
      </header>
		);
	};
}



// WEBPACK FOOTER //
// ./src/components/LandingPage.jsx